export default __webpack_public_path__ + "static/media/rectangle4.bff8aaaa.png";